module.exports = "<p>\r\n  auto-login works!\r\n</p>\r\n"